var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorklogCaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.158,
    height: 59.996,
    viewBox: "0 0 51.158 59.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_296",
    "data-name": "Subtraction 296",
    d: "M20089.057,13649h-30.941a10,10,0,0,1-10.113-10.1v-39.789a10,10,0,0,1,10.113-10.1h22.1a1.094,1.094,0,0,1,.883.384l17.684,17.68a1.09,1.09,0,0,1,.379.883v30.946A10,10,0,0,1,20089.057,13649Zm-17.686-37.9a1.269,1.269,0,1,0,0,2.538h.939v1.922l-.736.156a10.14,10.14,0,0,0-8.1,9.911,10.108,10.108,0,1,0,20.217,0,10.14,10.14,0,0,0-8.1-9.911l-.742-.156v-1.922h.939a1.269,1.269,0,1,0,0-2.538Zm10.115-17.8h0v10.669a2.831,2.831,0,0,0,2.7,2.714h10.674l-13.377-13.383Zm-7.9,39.9a7.445,7.445,0,1,1,5.387-2.18A7.557,7.557,0,0,1,20073.586,13633.2Zm0-11.053a1.159,1.159,0,0,0-1.275,1.271v2.209a1.271,1.271,0,1,0,2.541,0v-2.209A1.155,1.155,0,0,0,20073.586,13622.147Z",
    transform: "translate(-20048.002 -13589.002)",
    fill: "#1d0b77",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorklogCaption);
export default __webpack_public_path__ + "static/media/worklog-caption.14eeb13bf7abb95f633fe7f567042fb3.svg";
export { ForwardRef as ReactComponent };